import ua from '@tencent/docs-user-agent';
import { BHost, CHost } from "../constants";
import { removeURLParameter } from "./";
import { getUrlDomain } from "./get-target-domain";
var ECstParams;
/**
 * 老版本的 cst 相关参数,存在于老版本的客户端上.
 * 作用和前面的 CST_PARAMS 相同
 */

(function (ECstParams) {
  ECstParams["NAME"] = "wwapp_cst";
  ECstParams["VID"] = "wwapp_vid";
  ECstParams["DEVICE_ID"] = "wwapp_deviceid";
})(ECstParams || (ECstParams = {}));

var EOldCstParams;
/**
 * 删除cst相关的参数
 */

(function (EOldCstParams) {
  EOldCstParams["NAME"] = "cst";
  EOldCstParams["VID"] = "vid";
  EOldCstParams["DEVICE_ID"] = "deviceid";
})(EOldCstParams || (EOldCstParams = {}));

export function removeCst(url) {
  var _urlOriginal$shift;

  var host = getUrlDomain(url);

  if (!ua.isWxWork || ![BHost, CHost].includes(host)) {
    return url;
  }

  var urlOriginal = url.split('#');
  var urlString = (_urlOriginal$shift = urlOriginal.shift()) !== null && _urlOriginal$shift !== void 0 ? _urlOriginal$shift : '';
  var hashString = urlOriginal.join('#');
  var filedNames = [ECstParams.NAME, ECstParams.VID, ECstParams.DEVICE_ID, EOldCstParams.NAME, EOldCstParams.VID, EOldCstParams.DEVICE_ID];
  var newSearchString = urlString; // 把cst相关的参数都删掉.

  filedNames.forEach(function (fieldName) {
    newSearchString = removeURLParameter(newSearchString, fieldName);
  });

  if (!!hashString) {
    return "".concat(newSearchString, "#").concat(hashString);
  }

  return "".concat(newSearchString);
}